import { useCallback } from 'react';
import { Button, Colors, Icon } from '@mercator-gcp/grout';
import {
  useIsSavingProjectGroup,
  useNavigateBackToDashboard,
} from 'hooks/projectGroupEdit/useProjectGroupForm';
import { useDashboardGroupId } from 'state/dashboard';
import { useCloneQuery } from 'state/queryParams';

const buttonStyle = {
  color: Colors.TextQuiet,
  padding: 0,
  height: 'auto',
};

const BackButton = () => {
  const { navigateBackToDashboard } = useNavigateBackToDashboard();
  const [isSavingProjectGroup] = useIsSavingProjectGroup();
  const [groupId] = useDashboardGroupId();
  const { cloneQuery } = useCloneQuery();
  const isDuplicating = !!cloneQuery;

  const handleBackClick = useCallback(() => {
    if (isSavingProjectGroup) {
      return;
    }
    if (isDuplicating) {
      navigateBackToDashboard(Number(groupId));
    } else {
      navigateBackToDashboard(Number(groupId));
    }
  }, [isSavingProjectGroup, groupId, navigateBackToDashboard]);

  return (
    <Button
      sx={buttonStyle}
      onClick={handleBackClick}
      variant="unstyled"
      startAdornment={<Icon name={Icon.Name.ArrowLeft} />}
      isDisabled={isSavingProjectGroup}
    >
      Back without saving
    </Button>
  );
};

export default BackButton;
